<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2025-01-12 13:58:55
-->
<template>
  <div>
    <el-button @click="link">link</el-button>
    <el-button @click="occupy" :disabled="!isConnected">occupy</el-button>
    <el-button @click="leave">exit</el-button>
  </div>
</template>

<script>
import { clearAuthCache, getTenantId, getToken } from "../../utils/auth";
import catWSClient from "../../utils/wsClient/catClient";
export default {
  data() {
    return {
      isConnected: false,
    };
  },
  methods: {
    async link() {
      var token = getToken();
      console.log("# token:", token);
      this.ws2 = new catWSClient(
        "ws://localhost:8005/cat/ws?tId=" + getTenantId(),
        token
      );
      try {
        await this.ws2.connect();
        console.log("done?");
        this.isConnected = true;
      } catch (ex) {
        console.error(ex);
      }
    },
    occupy() {
      this.ws2.occupy("stu01", "17-25", "taskId", "fileId", null);
    },
    leave() {
    },
  },
};
</script>

<style>
</style>